import { useState } from "react";
import { useBooking } from "../context/BookingContext";

const panels = [
  {
    id: "artistry",
    eyebrow: "01 — Hair & Makeup",
    title: "Hair & Makeup Artistry",
    desc: "Editorial bridal styling, couture finishes, and timeless glamour crafted by master artists.",
    image: "https://images.pexels.com/photos/2065195/pexels-photo-2065195.jpeg",
    service: "Bridal Hair & Makeup",
  },
  {
    id: "scalp-lounge",
    eyebrow: "02 — Holistic Wellness",
    title: "The Scalp Lounge & Holistic Wellness",
    desc: "A sanctuary of restorative scalp therapies, botanical rituals, and architectural calm.",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_picaso-collections/artifacts/b831elhx_Gemini_Generated_Image_q11nq8q11nq8q11n.jpg",
    service: "Signature Scalp Ritual",
  },
];

export const SplitScreen = () => {
  const { openBooking } = useBooking();
  const [hovered, setHovered] = useState(null);

  return (
    <section data-testid="split-screen-section" className="relative">
      <div className="flex flex-col md:flex-row w-full h-auto md:h-screen">
        {panels.map((p) => {
          const isHovered = hovered === p.id;
          const isOther = hovered !== null && hovered !== p.id;
          const width = isHovered ? "65%" : isOther ? "35%" : "50%";
          return (
            <div
              key={p.id}
              data-testid={`split-panel-${p.id}`}
              onMouseEnter={() => setHovered(p.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => openBooking(p.service)}
              className="relative overflow-hidden group cursor-pointer h-[60vh] md:h-full w-full transition-all duration-[600ms]"
              style={{ flexBasis: width }}
            >
              {/* Image */}
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-[1200ms] group-hover:scale-105"
                style={{ backgroundImage: `url(${p.image})` }}
              />
              {/* Overlay - darker when other panel is hovered */}
              <div
                className={`absolute inset-0 transition-all duration-[600ms] ${
                  isOther ? "bg-black/70" : "bg-black/40 group-hover:bg-black/50"
                }`}
              />

              {/* Content */}
              <div className="relative z-10 h-full flex flex-col justify-end p-8 md:p-14">
                <p className="text-[#FDFBF7]/70 text-xs uppercase tracking-[0.3em] mb-4">
                  {p.eyebrow}
                </p>
                <h3 className="font-serif text-[#FDFBF7] font-light text-3xl md:text-5xl leading-tight max-w-md">
                  {p.title}
                </h3>
                <p className="text-[#FDFBF7]/80 font-light text-sm md:text-base mt-5 max-w-sm leading-[1.6]">
                  {p.desc}
                </p>

                <div
                  className={`overflow-hidden transition-all duration-[600ms] ${
                    isHovered ? "max-h-24 opacity-100 mt-8" : "max-h-0 opacity-0 mt-0 md:max-h-0"
                  }`}
                >
                  <button
                    data-testid={`explore-${p.id}-button`}
                    onClick={() => openBooking(p.service)}
                    className="inline-flex items-center gap-3 border border-[#FDFBF7]/60 text-[#FDFBF7] px-7 py-3 text-xs uppercase tracking-[0.2em] hover:bg-[#FDFBF7] hover:text-obsidian transition-all duration-500"
                  >
                    Explore Services →
                  </button>
                </div>

                {/* Mobile always-visible button */}
                <div className="md:hidden mt-6">
                  <button
                    onClick={() => openBooking(p.service)}
                    className="inline-flex items-center gap-3 border border-[#FDFBF7]/60 text-[#FDFBF7] px-6 py-3 text-xs uppercase tracking-[0.2em]"
                  >
                    Explore Services →
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default SplitScreen;
